import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { APIService } from 'api/module'
import { CustomFieldsService } from 'media.customFields'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { NotifyService } from 'common/util/services/notify.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class MergeCustomFieldsOp extends BaseOperation {
  icon = 'far fa-tasks'
  showInSelectionOverflowMenu = true
  supportsMultiple = true
  supportsBundles = true
  triggersReload = true
  weight = 90

  constructor (
    private translate: TranslateService,
    private mediaPermissions: MediaPermissionsService,
    private api: APIService,
    private panel: PanelService,
    private customFields: CustomFieldsService,
    private notify: NotifyService,
  ) {
    super()
    this.label = translate.instant('Merge custom fields into asset')
  }

  isVisibleForBundle (bundle, context) {
    const p = this.mediaPermissions.getPermissionForBundle(bundle)
    return context.location && !this.panel.active && bundle.mainfile && p?.allowWriteDb && p.showCustomFields && context.root.customFields.length > 0
  }

  async run ({ bundles }, context) {
    await Promise.all(bundles
      .map(async bundle => {
        const customFields = this.customFields.combine(
          context.location.effectiveCustomFields ?? {},
          bundle.asset.customFields ?? {},
          bundle.mainfile.customFields ?? {},
        )
        await this.api.mediaLibrary.patchAsset({
          id: bundle.asset.id,
          assetPartialUpdate: {
            customFields,
          },
          root: context.root.id,
        })
      }),
    )
    this.notify.info(this.translate.instant('Fields saved for selected assets'))
  }
}

MediaOperationsService.register(MergeCustomFieldsOp)
